<log-list-expanded-content
    (viewFullLog)="handleViewFullLog()"
>
    <div class="log-list-expanded-content__section log-list-expanded-content__section--no-padding-top">
        <log-significance
            *ngIf="isSignificantLog$ | async"
            [significantLog]="significantLog$ | async"
            [compactMode]="true"
        ></log-significance>
        <div class="traffic-log-list-expanded-content__communicating-ips">
            <traffic-log-list-expanded-content-communicating-ips></traffic-log-list-expanded-content-communicating-ips>
        </div>
    </div>
    <div class="log-list-expanded-content__section">
        <traffic-log-list-expanded-content-summary></traffic-log-list-expanded-content-summary>
    </div>
</log-list-expanded-content>
